// 검색조건 값 하나로 여러 키를 OR 검색해야 하는 경우의 키 목록
// 부서명: 목록 표기(author.section || author.company.com_name)와 같은 값으로 검색한다.
const orKeys = {
  "body.stdInfo.section": ["author.section", "author.company.com_name"],
};

export default function searchKeywordCondition(searchType, keyword) {
  const value = `%${keyword}%`;
  const keys = orKeys[searchType];
  if (!keys) {
    return { key: searchType, operator: "LIKE", value };
  }

  // 976/1229 List.js와 같은 형태: AND 그룹 안에서 두 번째 키부터 boolean: "OR"
  const subConditions = keys.map((key, index) => {
    if (index === 0) return { key, operator: "LIKE", value };
    return { key, operator: "LIKE", value, boolean: "OR" };
  });
  return { boolean: "AND", conditions: subConditions };
}
